var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayValue)?_c('div',{staticClass:"issue-tracker__item hidden-sm-down"},[_c('span',{staticClass:"issue-tracker__tag",class:[_vm.getTagColor]},[_vm._v(_vm._s(_vm.displayValue))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }